import { render } from "./LoadingScreen.vue?vue&type=template&id=03fb77f2"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=03fb77f2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__